import orderInstance from './instance'
import orderModalLoginInstance from './modalLoginInstance'

const createOrder = (data, hasModalLogin = false) => {
	return (hasModalLogin ? orderModalLoginInstance : orderInstance).post('/orders', data)
}

export default createOrder
